import { Tag } from "antd";

const QuickTag: React.FC<{ isQuick: boolean }> = ({ isQuick }) => {
    return (
        isQuick ? <Tag color="success">예</Tag> : <Tag color="default">아니오</Tag>
    );
};

export default QuickTag;